import { render, staticRenderFns } from "./BackgroundImage.vue?vue&type=template&id=fb530e44&scoped=true&"
import script from "./BackgroundImage.vue?vue&type=script&lang=js&"
export * from "./BackgroundImage.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundImage.vue?vue&type=style&index=0&id=fb530e44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb530e44",
  null
  
)

export default component.exports